// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";
import * as FaTimes from "@fortawesome/pro-regular-svg-icons/faTimes";

var closeButton = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.background("transparent"),
      BsCssJs$PrezzeeRibbon.border(BsCssJs$PrezzeeRibbon.px(0), "solid", "transparent"),
      BsCssJs$PrezzeeRibbon.padding(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.position("absolute"),
      BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.px(-30)),
      BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.px(-5)),
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(30)),
      BsCssJs$PrezzeeRibbon.hover([BsCssJs$PrezzeeRibbon.cursor("pointer")])
    ]);

var Styles = {
  closeButton: closeButton
};

function Modal__Close(props) {
  var closeFunc = props.closeFunc;
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                    icon: FaTimes.faTimes
                  }),
              "aria-label": "Close modal",
              className: Classnames([
                    closeButton,
                    className$1
                  ]),
              onClick: (function (param) {
                  Curry._1(closeFunc, undefined);
                })
            });
}

var make = Modal__Close;

export {
  Styles ,
  make ,
}
/* closeButton Not a pure module */
